// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__1k5zm","second":"return_second__2LjiT","link":"return_link__PA9aL"};